import LangEnum from '../../../../../lang/LangEnum';
import { TranslateType } from '../../../../translation/translationContext.types';
import {
  ExportCatalogImageModelOption,
  ExportImageModel,
  ExportMethod,
  ExportQuality,
  ExportType,
} from '../types/catalogExportModal.types';

export const exportImageModelOptions: ExportCatalogImageModelOption[] = [
  {
    value: ExportImageModel.MEDIUM,
    label: LangEnum.CATALOGS_EXPORT_MEDIUM_IMAGE_MODEL_LABEL,
    subtitle: LangEnum.CATALOGS_EXPORT_MEDIUM_IMAGE_MODEL_SUBTITLE,
  },
  {
    value: ExportImageModel.LARGE,
    label: LangEnum.CATALOGS_EXPORT_LARGE_IMAGE_MODEL_LABEL,
    subtitle: LangEnum.CATALOGS_EXPORT_LARGE_IMAGE_MODEL_SUBTITLE,
  },
];

export const ExportOptions = [
  {
    label: 'e-mail',
    value: ExportMethod.EMAIL,
  },
  { label: 'download', value: ExportMethod.DOWNLOAD },
];

export const getTypeOptions = (translate: TranslateType) => [
  {
    label: 'pdf',
    value: ExportType.PDF,
  },
  {
    label: translate(LangEnum.CATALOGS_EXPORT_XLSX_FOR_IMPORT_LABEL),
    value: ExportType.XLSX,
  },
];

export const getQualityOptions = (translate: TranslateType) => [
  {
    label: translate(LangEnum.CATALOGS_EXPORT_HIGH_QUALITY_LABEL),
    value: ExportQuality.HIGH,
  },
  {
    label: translate(LangEnum.CATALOGS_EXPORT_LOW_QUALITY_LABEL),
    value: ExportQuality.LOW,
  },
];
